import { jsx } from "panel";
import { DropMenuEl } from "common/components/drop-menu";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".reports-menu-container"
  }, this.attr(`open`) && /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: { open: true },
    on: { change: this.helpers.handleDropMenuChange },
    props: { positionParent: this }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".reports-menu-dropdown"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".reports-menu-category"
  }, this.helpers.getReports().map((report) => /* @__PURE__ */ jsx("a", {
    sel: ".reports-menu-section",
    class: {
      [`reports-menu-section-${this.helpers.getClassSuffix(report)}`]: true,
      "reports-menu-section-disabled": report.disabled
    },
    attrs: {
      href: !report.disabled && this.helpers.getReportUrl(report.endpoint, {
        projectId: this.attr(`project-id`),
        workspaceId: this.attr(`workspace-id`)
      })
    },
    on: { click: (ev) => this.helpers.handleClickReportName(ev, report) }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".reports-menu-section-image"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".reports-menu-section-image-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: report.icon }
  }))), /* @__PURE__ */ jsx("div", {
    sel: ".reports-menu-section-text"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".reports-menu-title"
  }, report.label, report.beta && /* @__PURE__ */ jsx("span", {
    sel: ".reports-menu-beta-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `beta-tag` }
  }))), /* @__PURE__ */ jsx("div", {
    sel: ".reports-menu-description"
  }, report.description)), report.disabled && /* @__PURE__ */ jsx(TooltipEl, null, report.disabled)))))));
}
